export default __webpack_public_path__ + "images/is-2dfa14d19684fbe061e4e81ef473aed2.svg";